<template>
  <DataTable v-model:filters="filters"
             ref="dt"
             class="app-datatable"
             :filterButtonProps="{ filter: { class: 'app-dt-filter-btn' } }"
             v-model:editingRows="editingRows"
             editMode="cell"
             @row-edit-save="onRowEditSave"
             @cell-edit-complete="onRowEditSave"
             :value="rows"
             size="small"
             filterDisplay="menu"
             removableSort
             scrollable
             paginator
             :rows="20"
             stateStorage="session" :stateKey="modulo+'-session'"
             :globalFilterFields="globalfilters"
             :pt="{
                table: { style: 'min-width: 50rem' },
                column: {
                    bodycell: ({ state }) => ({
                        style:  state['d_editing']&&'padding-top: 0.75rem; padding-bottom: 0.75rem'
                    })
                }
            }">
    <template #header>
      <div class="flex justify-between container-button-e-search">
        <div class="icon-action-datatable-container">
          <Button class="icon-action-datatable" text icon="pi pi-filter-slash" @click="clearFilter()"/>
          <Button v-if="add_action" as="a" class="icon-action-datatable" text icon="pi pi-plus" :href="add_action"/>
        </div>
        <IconField class="ricerca-search">
          <InputText v-model="searchQuery" @keyup.enter="onSearchInput" :placeholder="$root.trans.cerca" class="input-cerca"/>
          <InputIcon>
            <i :class="searchLoading ? 'pi pi-spin pi-spinner' : 'pi pi-search'" @click="onSearchInput" style="cursor:pointer"/>
          </InputIcon>
        </IconField>
      </div>
    </template>
    <template #empty>{{ mess_vuoto || $root.trans.nessun_dato_da_caricare || 'Nessun dato da caricare' }}</template>
    <template #loading> {{ mess_caricamento }}</template>
    <template v-if="Object.keys(actions).length > 0">
      <Column :exportable="false">
        <template #body="slotProps">
          <template v-if="!slotProps.data.use_fallback_action">
            <template v-for="(action, key) in actions">
              <template v-if="!['aggiorna' , 'elimina','componente','fallback'].includes(key)">
                <a :href="generateUrl(action, slotProps.data)"
                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                  <i :class="'pi '+action.icona"></i>
                </a>
              </template>
              <template v-if="key === 'elimina'">
                <a @click="rimuoviRiga(action , slotProps.data )"
                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                  <i :class="'pi '+action.icona"></i>
                </a>
              </template>
              <template v-if="key === 'componente'">
                <component
                  :is="component(action.componente)"
                  v-bind="actionComponentProps({...slotProps.data, ...action.componente.props})"
                />
              </template>
            </template>
          </template>
          <template v-else>
              <span class="mx-1 p-button p-button-icon-only p-button-secondary p-button-rounded p-button-text" v-tooltip="actions['fallback'].message">
                <i :class="'text-yellow-600 pi '+actions['fallback'].icona"></i>
              </span>
          </template>
        </template>
      </Column>
    </template>
    <Column v-for="column of columns" :field="column.name"
            :header="column.title"
            sortable :filter="column.filtro !== false">
      <template #sorticon="slotProps">
        <span :class="['app-dt-icon', slotProps.sorted ? (slotProps.sortOrder === 1 ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down-alt') : 'pi pi-sort-alt']"></span>
      </template>
      <template #filtericon>
        <span class="pi pi-filter app-dt-icon"></span>
      </template>
      <template #editor="{ data, field }">
        <template v-if="column.formato === 'select' ">
          <Select v-model="data[field]" :options="data['options_'+field] ?? column.options" optionLabel="nome" optionValue="id"
                  placeholder="Select a Status" fluid :disabled="column.disabled || !data[column.conditional_enabled]">
            <template #option="slotProps">
              <div> {{ slotProps.option.nome }} </div>
            </template>
          </Select>
        </template>
        <template v-else>
          <InputText v-model="data[field]" fluid :disabled="column.disabled"/>
        </template>
      </template>
      <template #body="{data}">
        <template v-if="column.formato === 'data'">
          {{ data[column.name] != '' && data[column.name] != null ? formatDate(data[column.name]) : '' }}
        </template>
        <template v-else-if="column.formato === 'dataora'">
          {{ data[column.name] != '' && data[column.name] != null ? formatDateTime(data[column.name]) : '' }}
        </template>
        <template v-else-if="column.formato === 'ora'">
          {{ formatTime(data[column.name]) }}
        </template>
        <template v-else-if="column.formato === 'num_intero'">
          {{ formatNumberInt(data[column.name]) }}
        </template>
        <template v-else-if="column.formato === 'num_decimale'">
          {{ formatNumberDecimal(data[column.name]) }}
        </template>
        <template v-else-if="column.formato === 'prezzo'">
          {{ formatCurrency(data[column.name]) }}
        </template>
        <template v-else-if="column.formato === 'colore'">
          <span v-html="formatColor(data[column.name])"></span>
        </template>
        <template v-else-if="column.formato === 'select'">
          {{ formatSelectId(data, column) }}
        </template>
        <template v-else-if="column.formato === 'componenti'">
          <template v-for="componente in data[column.name]">
            <component
              :is="component(componente)"
              v-bind="componentProps(componente)"
            />
          </template>
        </template>
        <template v-else>
          {{ data[column.name] }}
        </template>
      </template>
      <template #filter="{ filterModel }">
        <template v-if="column.formato === 'data'">
          <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd" placeholder="mm/dd/yyyy"/>
        </template>
        <template v-else-if="column.formato === 'dataora'">
          <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd hh:mm" placeholder="mm/dd/yyyy hh:mm" showTime
                      hourFormat="24"/>
        </template>
        <template v-else-if="column.formato === 'ora'">
          <DatePicker v-model="filterModel.value" dateFormat="hh:mm" placeholder="hh:mm" timeOnly hourFormat="24"/>
        </template>
        <template v-else-if="column.formato === 'colore'">
          <ColorPicker v-model="filterModel.value"/>
        </template>
        <template v-else>
          <InputText v-model="filterModel.value" type="text" :placeholder="column.title"/>
        </template>
      </template>
    </Column>
  </DataTable>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputNumber from 'primevue/inputnumber';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import Button from 'primevue/button';
import DatePicker from 'primevue/datepicker';
import ColorPicker from 'primevue/colorpicker';
import {FilterMatchMode, FilterOperator} from '@primevue/core/api';
import Select from 'primevue/select';
import {resolveComponent} from 'vue';
import {toRaw} from 'vue';

import Tag from 'primevue/tag';

export default {
  name: "DatatableCellEdit",
  props: ['modulo', 'colonne', 'route_righe', 'azioni', 'add_action', 'mess_vuoto', 'mess_caricamento','filtri_custom','route_params'],
  components: {
    DataTable,
    Column,
    InputNumber,
    InputText,
    InputIcon,
    IconField,
    Button,
    DatePicker,
    ColorPicker,
    Select,
    Tag
  },
  data() {
    return {
      filters: {},
      loading: true,
      rows: [],
      // se ho fatto json_encode in php non serve json parse , vue lo interpreta già come un oggetto
      columns: this.colonne,
      actions: this.azioni,
      globalfilters: [],
      editingRows: [],
      customFilters: this.filtri_custom,
      searchQuery: '',
      searchLoading: false
    }
  },
  async beforeCreate() {
    console.log("beforeCreate");
    const righe = await axios.get(route(this.route_righe, this.route_params));
    console.log(righe);
    if (righe.status === 200) {
      this.rows = righe.data;
    } else {
      // Qui ci sarebbe da gestire l'errore se la chiamata non va a buon fine
      this.rows = [];
    }
  },
  async created() {

    this.initFilters();
    this.globalfilters = this.columns
      .filter((column) => column.filtro !== false)
      .map((column) => column.globalFilterField ?? column.name);
    console.log("filtri globali")
    console.log(this.customFilters);
    this.globalfilters = [...this.globalfilters, ...(this.customFilters ?? [])];
    console.log("filtri creati")
    console.log(...this.globalfilters);
    console.log({...this.filters});

  },
  async mounted() {
    this.loading = false;
    this.stripFilterButtonClasses();
  },
  updated() {
    this.stripFilterButtonClasses();
  },
  methods: {
    stripFilterButtonClasses() {
      this.$nextTick(() => {
        const tableRoot = this.$refs.dt?.$el || this.$refs.dt;
        if (!tableRoot) return;

        tableRoot.querySelectorAll('.p-datatable-column-header-content .p-datatable-filter button').forEach((button) => {
          button.classList.remove('p-button', 'p-component', 'p-button-icon-only');
        });
      });
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },
    formatDateTime(value) {
      const date = new Date(value).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      const time = new Date(value).toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit'
      });
      return date + " " + time;
    },
    formatTime(value) {
      const timeString = `1970-01-01T${value}`; // Adding a dummy date
      return new Date(timeString).toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formatCurrency(value) {
      return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
    },
    formatNumberInt(value) {
      return value.toLocaleString("it-IT", {minimumFractionDigits: 0, maximumFractionDigits: 0});
    },
    formatNumberDecimal(value) {
      return value.toLocaleString("it-IT", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    formatColor(value) {
      return '<i class="pi pi-circle-fill" style="color:' + value + '">';
    },
    formatSelectId(row, column) {
      return column.options.find((option) => option.id === (row[column.name] ?? 0)).nome;
    },
    onSearchInput() {
      this.searchLoading = true;
      this.filters['global'].value = this.searchQuery;
      this.searchLoading = false;
    },
    clearFilter() {
      this.searchQuery = '';
      this.initFilters();
    },
    initFilters() {
      this.filters = {};
      // init custom filters first
      if(this.customFilters){
        this.customFilters.forEach((filter)=>{
          this.filters[filter] = {
            operator: FilterOperator.AND,
            constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
          }
        })
      }
      this.filters['global'] = {value: null, matchMode: FilterMatchMode.CONTAINS};
      this.columns.forEach(column => {
        if (column.formato === 'data') {
          this.filters[column.name] = {
            operator: FilterOperator.AND,
            constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
          }
        } else if (column.formato === 'dataora') {
          this.filters[column.name] = {
            operator: FilterOperator.AND,
            constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
          }
        } else if (column.formato === 'ora') {
          this.filters[column.name] = {
            operator: FilterOperator.AND,
            constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
          }
        } else if (column.formato === 'colore') {
          this.filters[column.name] = {
            operator: FilterOperator.AND,
            constraints: [{value: null, matchMode: 'equals'}]
          }
        } else {
          this.filters[column.name] = {
            operator: FilterOperator.AND,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
          }
        }
      });
    },

    generateUrl(action, rowData) {
      console.log(rowData);
      const params = action.parametri.reduce((acc, param) => {
        acc[param] = rowData[param];
        return acc;
      }, {});

      return route(action.url, params);
    },
    component(name) {
      return resolveComponent(name.component);
    },
    componentProps(name) {
      const rawProps = toRaw(name.props ?? {});
      for (const [key, value] of Object.entries(rawProps?.functions ?? {})) {
        rawProps[key] = new Function(value);
      }
      return rawProps;
    },
    actionComponentProps(name) {
      const rawProps = toRaw(name ?? {});
      for (const [key, value] of Object.entries(rawProps?.functions ?? {})) {
        rawProps[key] = new Function(value);
      }
      return rawProps;
    },
    onRowEditSave: async function (event) {
      this.rows[this.rows.indexOf(event.data)] = event.newData;
      await axios.post(route(this.azioni['aggiorna'].url), event.newData);

    },
    rimuoviRiga: async function (action, elemento) {
      if (confirm(`${this.$root.trans.eliminare} ${elemento.nome ?? ` ${this.$root.trans.l_elemento_selezionato}`} ?`)) {
        const response = await axios.post(route(action.url, {id: elemento.id}),);
        if (response.status == 200) {
          this.rows.splice(this.rows.indexOf(elemento), 1);
          this.$toast.add({
            severity: 'success',
            summary: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato}`,
            detail: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato} ${this.$root.trans.correttamente}`,
            life: 3000
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: `${response.status}`,
            detail: `${this.$root.trans.elemento}: ${elemento.nome ?? this.$root.trans.elemento} `,
            life: 3000
          })
        }
      }
    },
  }
}

</script>


<style scoped>

</style>
